module.exports = __webpack_public_path__ + "img/pin-blue.8525fbcc.svg";